import React, { useState, useEffect, FC, useMemo, useCallback } from "react";
import {
  Badge,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  Card,
  Spinner,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import { FormProvider, useForm } from "react-hook-form";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Form,
  TableColumnsType,
  Input,
  Table,
  Timeline,
  Collapse as AntCollapse,
  Modal as AntModal,
  Flex,
  Spin,
  Space,
  Divider,
} from "antd";
import FormSelect from "../form-components/SelectComponent";
import FormInput from "../form-components/InputComponent";
import FormDatePicker from "../form-components/DatePicker";
import deliveryAddressApis from "../../api/master/deliveryAddress";
import { Popover } from "antd";
import Swal from "sweetalert2";
import MaterialModal from "./EditPRMaterialModal";
import dayjs from "dayjs";
import { useParams, useLocation } from "react-router";
import { useNavigate } from "react-router";
import "react-quill/dist/quill.snow.css";
import purchaseRequestApis from "../../api/master/purchaseRequest";
import { Link } from "react-router-dom";
import PdfGenerator from "./PRPDF";
import { flattenSiteStructuresToRows, groupMaterialsBySiteStructure } from "../../utils/Utils";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { formatDecimal } from "../../utils/Utils";
import contractorsApis from "../../api/master/contractors";
import misc from "../../api/misc/dropDowns";
import supplierApis from "../../api/master/supplier";
import sites from "../../api/master/sites";
import boqApis from "../../api/boq/boq";
import SignatureModal from "../purchase-orders/SignatureModal";
import ImageUploadCropper from "../components/ImageUploadCropper";

const { Panel } = AntCollapse;

const WORK_LEVEL_LABELS: Record<string, string> = {
  TOWER_BLOCK: "Tower / Block",
  VILLA: "Villa",
  FLOOR: "Floor",
  FLAT: "Flat",
  NONE: "Order Level",
  Tower: "Tower",
  Villa: "Villa",
  Floor: "Floor",
  Flat: "Flat",
};

const SEGMENT_TO_WORK_LEVEL: Record<string, string> = {
  Tower: "TOWER_BLOCK",
  "Tower/Block": "TOWER_BLOCK",
  "Tower / Block": "TOWER_BLOCK",
  "Tower/ Block": "TOWER_BLOCK",
  Block: "TOWER_BLOCK",
  Villa: "VILLA",
  Floor: "FLOOR",
  Flat: "FLAT",
};

const HIERARCHY_UNIT_TITLES: Record<string, string> = {
  TOWER_BLOCK: "Tower / Block",
  VILLA: "Villa",
  FLOOR: "Floor",
  FLAT: "Flat",
};

interface SelectOptions {
  label: string;
  value: string;
}

// Stable client-side row identity. Newly added / bulk-uploaded PR lines have
// no prLineId or prLineSiteStructureId (both null), so matching an edited row
// by those keys collides (null == null) and updates every new row at once.
let __prRowUidCounter = 0;
const makeRowUid = () => `pr-row-${Date.now()}-${++__prRowUidCounter}`;

const ViewPRDetails: FC<any> = () => {
  const { data: currentUser }: any = useSelector(
    (state: RootState) => state.currentUser
  );
  const { data: accessibility } = useSelector(
    (state: any) => state.accessibility
  );
  const [allowedActions, setAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });
  const [rfqAllowedActions, setRfqAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });
  const [approverIds, setApproverIds] = useState<any>([]);
  const [currentUserId, setCurrentUserId] = useState<any>(null);
  const methods = useForm({
    mode: "onChange",
  });
  const [materialCategoryOptions, setMaterialCategoryOptions] = useState([]);
  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;
  const [isLoading, setIsLoading] = useState(true);
  let { prId }: any = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [OriginalData, setOriginalData] = useState<any>({});
  const [poStatus, setPoStatus] = useState<any>("");
  const [showSubmitBtm, setShowSubmitBtm] = useState(false);
  const [sm, setSm] = useState(false);
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [materialData, setMaterialData] = useState<any>({});

  const [deliveryAddressList, setDeliveryAddressList] = useState<any>([]);

  const [sitesOptions, setSitesOptions] = useState<SelectOptions[]>([]);
  const [blockOptions, setBlockOptions] = useState<SelectOptions[]>([]);
  const [contractorOptions, setContractorOptions] = useState<SelectOptions[]>(
    []
  );
  const [usersOptions, setUsersOptions] = useState<SelectOptions[]>([]);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [disableDraft, setDisableDraft] = useState(false);
  const [deliveryAddressOptions, setDeliveryAddressOptions] = useState<
    SelectOptions[]
  >([]);

  const [signature, setSignature] = useState({
    isActive: false,
    label: "Authorised Signatory",
    image: null as string | null,
  });

  const [showSignatureModel, setShowSignatureModel] = useState(false);

  const [isModalApproveVisible, setIsModalApproveVisible] = useState(false);
  const [approveRecord, setApproveRecord] = useState<any>(null);
  const [activeSignatureContext, setActiveSignatureContext] = useState<
    "APPROVE" | "REJECT" | null
  >(null);

  const [isStrictMode, setIsStrictMode] = useState<boolean>(false);
  const [boqData, setBoqData] = useState<any[]>([]);

  const headerWorkLevelSetting = useMemo(() => {
    const workLevel = materialData?.prHeader?.workLevelSetting;
    if (workLevel && workLevel !== "NONE") {
      return workLevel;
    }
    const segment = materialData?.prHeader?.segmentLevel;
    return segment ? SEGMENT_TO_WORK_LEVEL[segment] ?? null : null;
  }, [
    materialData?.prHeader?.segmentLevel,
    materialData?.prHeader?.workLevelSetting,
  ]);

  const hierarchyUnitColumnTitle = useMemo(() => {
    if (!headerWorkLevelSetting || headerWorkLevelSetting === "NONE") {
      return "Tower / Block / Villa";
    }
    if (
      headerWorkLevelSetting === "FLOOR" ||
      headerWorkLevelSetting === "FLAT"
    ) {
      return "Tower / Block";
    }
    return HIERARCHY_UNIT_TITLES[headerWorkLevelSetting] ?? "Tower / Block";
  }, [headerWorkLevelSetting]);

  const hierarchyVis = useMemo(() => {
    const lines = materialData?.prLines ?? [];
    const derivedSegment =
      lines.some(
        (item: any) =>
          item?.segmentLevel &&
          item.segmentLevel.toString().toLowerCase() !== "null"
      ) || !!headerWorkLevelSetting;
    const derivedTower =
      lines.some(
        (item: any) =>
          item?.towerBlockVillaId ||
          item?.towerBlockVillaName ||
          item?.siteStructureUnitId ||
          item?.siteStructureUnitName
      ) || !!materialData?.prHeader?.towerBlockVillaName;
    const derivedFloor =
      lines.some((item: any) => item?.floorNo) ||
      !!materialData?.prHeader?.floorNo;
    const derivedFlat =
      lines.some(
        (item: any) =>
          item?.siteStructureSubUnitId ||
          item?.siteStructureSubUnitName ||
          item?.flatLabel
      ) || !!materialData?.prHeader?.flatLabel;
    const derivedLocation =
      lines.some((item: any) => item?.locationId || item?.locationName) ||
      !!materialData?.prHeader?.locationName;

    return {
      segmentLevel: derivedSegment,
      tower: derivedTower,
      floor: derivedFloor,
      flat: derivedFlat,
      location: derivedLocation,
    };
  }, [
    headerWorkLevelSetting,
    materialData?.prHeader?.flatLabel,
    materialData?.prHeader?.floorNo,
    materialData?.prHeader?.locationName,
    materialData?.prHeader?.towerBlockVillaName,
    materialData?.prLines,
  ]);

  const deriveLineWorkLevel = useCallback(
    (line: any) => {
      if (line?.workLevelSetting && line.workLevelSetting !== "NONE") {
        return line.workLevelSetting;
      }
      if (line?.segmentLevel) {
        return SEGMENT_TO_WORK_LEVEL[line.segmentLevel] ?? null;
      }
      return headerWorkLevelSetting ?? null;
    },
    [headerWorkLevelSetting]
  );

  const getSiteHierarchyLabel = useCallback(
    (line: any) => {
      const workLevel = deriveLineWorkLevel(line);
      if (!workLevel) {
        return (
          line?.segmentLevel || materialData?.prHeader?.segmentLevel || "-"
        );
      }
      return (
        WORK_LEVEL_LABELS[workLevel] ||
        WORK_LEVEL_LABELS[line?.segmentLevel] ||
        workLevel ||
        "-"
      );
    },
    [deriveLineWorkLevel, materialData?.prHeader?.segmentLevel]
  );

  const getTowerLabel = useCallback((line: any) => {
    return (
      line?.towerBlockVillaName ||
      line?.towerBlockVillaLabel ||
      line?.siteStructureUnitName ||
      "-"
    );
  }, []);

  const getFlatLabel = useCallback((line: any) => {
    return (
      line?.flatLabel ||
      line?.siteStructureSubUnitName ||
      line?.flatName ||
      "-"
    );
  }, []);

  const getLocationLabel = useCallback((line: any) => {
    return line?.locationLabel || line?.locationName || "-";
  }, []);

  const [showActionModelVisible, setShowActionModelVisible] = useState(false);
  const [editLineRow, setEditLineRow] = useState<any>();
  const [generalInformationEdit, setGeneralInformationEdit] = useState(false);

  const [form] = Form.useForm();

  const siteIdWatch = watch("siteId");
  const levelTypeWatch = watch("levelType");

  const [addNewRowModel, setAddNewRowModel] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);

  const [isModalRejectedVisible, setIsModalRejectedVisible] = useState(false);
  const [rejectRecord, setRejectRecord] = useState<any>(null);

  useEffect(() => {
    if (siteIdWatch) {
      fetchContractorList(siteIdWatch + "");
    }
  }, [siteIdWatch]);

  useEffect(() => {
    if (siteIdWatch) {
      fetchUsers(siteIdWatch);
      fetchBlockList(siteIdWatch);
      fetchDeliveryAddressBySite(siteIdWatch);
      setValue("deliveryAddressId", "");
    }
  }, [siteIdWatch]);
  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility, id } = currentUser;
      setCurrentUserId(id);
      if (siteAccessibility) {
        const sitesOptions = siteAccessibility?.map((item: any) => ({
          label: item.siteName,
          value: item.siteID.toString(),
        }));
        setSitesOptions(sitesOptions);
      }
    }
  }, [currentUser]);
  useEffect(() => {
    fetchPRDetails();
    fetchDeliveryAddress();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const fetchCategorys = async (siteId?: string | number) => {
    try {
      const { data, status } = await supplierApis.fetchSupplierCategory(siteId);
      if (status) {
        const categoryOption = data.map((item: any) => ({
          label: item.category,
          value: item.id.toString(),
        }));
        setMaterialCategoryOptions(categoryOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };
  const fetchPRDetails = async () => {
    try {
      const res = await purchaseRequestApis.getById(prId);
      const { response, status, message } = res;
      if (status) {
        let data: any = response;

        const isStrict =
          data?.prHeader?.isStrictApproval === true || data?.prHeader?.isStrictApproval === 1;

        setIsStrictMode(isStrict);


        if (data?.prApprovals) {
          const processedApprovals = data.prApprovals.map((approval: any) => ({
            ...approval,
            level: approval.level?.toLowerCase() || approval.level,
            status: approval.status?.toLowerCase() || approval.status
          }));
          data.prApprovals = processedApprovals;

          // Filter pending approvals
          let ids = processedApprovals
            ?.filter((item: any) => item?.status?.toLowerCase() !== "approved")
            ?.map((item: any) => item?.userId);
          setApproverIds(ids);
        }

        data?.prLines?.forEach((item: any) => {
          item.headerStaus = data?.prHeader?.status;
        });
        // Snapshot the unflattened lines so downstream checks (convert gate)
        // can still read line-level `status` / `awardedQty`.
        setOriginalData({
          ...data,
          prLines: Array.isArray(data?.prLines)
            ? data.prLines.map((l: any) => ({ ...l }))
            : data?.prLines,
        });
        setPoStatus(data?.prHeader?.status);

        // Flatten siteStructures[] to UI rows for editing (handles new & old PR formats)
        if (data?.prLines) {
          const flattenedLines = flattenSiteStructuresToRows(data.prLines);
          data.prLines = flattenedLines.map((line: any) => ({
            ...line,
            rowUid: makeRowUid(),
          }));
        }

        setMaterialData(data);
        const headerSiteId = data?.prHeader?.siteId;
        const headerContractorId = data?.prHeader?.contractorId;
        // Fetch BOQ data for PR remaining quantity validation
        if (headerSiteId && headerContractorId) {
          try {
            const boqResponse = await boqApis.fetchContractorBoqDropdown({
              siteIds: headerSiteId.toString(),
              contractorIds: headerContractorId.toString(),
            });
            const boqList = boqResponse?.data || boqResponse?.response || [];
            setBoqData(Array.isArray(boqList) ? boqList : []);
          } catch (err) {
            console.log("Failed to fetch BOQ data:", err);
            setBoqData([]);
          }
        }
        if (headerSiteId) {
          fetchCategorys(headerSiteId);
        } else {
          fetchCategorys();
        }
        const LineItems = data?.prLines;
        setData(LineItems);
        setShowSubmitBtm(false);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const parseLevelNum = (level: any) => {
    if (!level && level !== 0) return NaN;
    const str = String(level).toLowerCase();

    // Handle various level formats: level1, Level2, L1, L2, etc.
    if (str.includes('level')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    } else if (str.startsWith('l')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    }
    return NaN;
  };

  const hasUserAlreadyApproved = materialData?.prApprovals?.some(
    (a: any) =>
      a.userId === currentUserId &&
      a.status?.toUpperCase() === "APPROVED"
  );

  const canUserApproveReject = useCallback(() => {
    // 1. Check if PR status is PENDING
    if (materialData?.prHeader?.status?.toLowerCase() !== "pending") {
      return false;
    }

    // 2. Admin can Approve/Reject anytime
    if (currentUser?.genericRole?.toLowerCase() === "admin") {
      return true;
    }

    const approvals = materialData?.prApprovals || [];

    // Find current user's approval entry
    const userApproval = approvals.find(
      (approval: any) => approval.userId === currentUserId
    );

    if (!userApproval || userApproval.status?.toLowerCase() !== "pending") {
      return false;
    }

    if (userApproval && userApproval.status?.toUpperCase() === "APPROVED") {
      return false;
    }

    const userLevelNum = parseLevelNum(userApproval.level ?? currentUser?.approvalLevel);

    // 3. Strict = 0 (Flexible mode) - Anyone in the approval list can approve
    if (isStrictMode === false) {
      return true;
    }

    // 4. Strict = 1 (Sequential mode) - Must follow the order
    if (isStrictMode === true) {
      // Get all pending approvals sorted by level
      const pendingApprovals = approvals
        .filter((approval: any) => approval.status?.toLowerCase() === "pending")
        .sort((a: any, b: any) => {
          const aNum = parseLevelNum(a.level);
          const bNum = parseLevelNum(b.level);
          if (isNaN(aNum) || isNaN(bNum)) return 0;
          return aNum - bNum;
        });

      // If there are no pending approvals, user can't approve
      if (pendingApprovals.length === 0) return false;

      // Get the first pending approval (lowest level)
      const firstPending = pendingApprovals[0];
      const firstPendingLevelNum = parseLevelNum(firstPending.level);

      // Check if user is the first pending approver
      return userApproval.userId === firstPending.userId &&
        userLevelNum === firstPendingLevelNum;
    }

    return false;
  }, [currentUser, currentUserId, materialData?.prApprovals, isStrictMode, materialData?.prHeader?.status]);

  const getPendingStatusMessage = () => {
    const approvals = materialData?.prApprovals || [];
    const userApproval = approvals.find(
      (approval: any) => approval.userId === currentUserId
    );

    if (userApproval && userApproval.status?.toUpperCase() === "APPROVED") {
      return "You have already approved this purchase request.";
    }

    const pendingApprovals = approvals
      .filter((approval: any) => approval.status?.toLowerCase() === "pending")
      .sort((a: any, b: any) => {
        const aNum = parseLevelNum(a.level);
        const bNum = parseLevelNum(b.level);
        if (isNaN(aNum) || isNaN(bNum)) return 0;
        return aNum - bNum;
      });

    if (pendingApprovals?.length > 0) {
      if (!isStrictMode) {
        // Flexible mode - any approver can approve
        const approverNames = pendingApprovals.map((approval: any) => approval.userName).join(", ");
        return `Status is pending. Any of these approvers can approve: ${approverNames}`;
      } else {
        // Strict mode - must follow sequence
        const nextApprover = pendingApprovals[0];
        const lvl = parseLevelNum(nextApprover.level);
        const levelText = !isNaN(lvl) ? `Level ${lvl}` : nextApprover.roleName || "";
        return `Status is pending. Waiting for ${nextApprover.userName} (${levelText}) to approve first.`;
      }
    }

    return "Status is pending by other approvers";
  };

  const ShowAddressPopOver = ({ id }: any) => {
    if (!id) {
      return <></>;
    }
    let address = deliveryAddressList?.find((item: any) => item?.id == id);
    if (!address) {
      return <></>;
    }
    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>
            {address?.deliveryLocationName}
          </strong>
        </li>
        <li>{address?.addressLine1}</li>
        <li>{address?.addressLine2}</li>
        <li>
          {address?.city}, {address?.stateName}, {address?.countryName} -{" "}
          {address?.pincode}
        </li>
      </ul>
    );
  };

  const fetchContractorList = async (siteId: any) => {
    try {
      const { data, status } = await contractorsApis.fetchContractorBySiteId({
        id: siteId,
      });
      if (status) {
        let contractorOptions = data.map((item: any) => ({
          label: item?.companyName,
          value: item?.contractorID?.toString(),
        }));
        setContractorOptions(contractorOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchUsers = async (siteId: any) => {
    try {
      const data = await misc.fetchSiteUsers(siteId);
      if (data) {
        let usersOptions = data?.data?.map((item: any) => ({
          label: item.userName,
          value: item.userId.toString(),
        }));
        setUsersOptions(usersOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBlockList = async (siteId: any) => {
    try {
      const { data, status } = await sites.fetchBlockById(siteId);
      if (status) {
        let blockOptions = data.map((item: any) => ({
          label: item.blockName,
          value: item.blockID.toString(),
        }));
        setBlockOptions(blockOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDeliveryAddress = async () => {
    try {
      const { data, status } = await deliveryAddressApis.fetchDeliveryAddress();
      if (status) {
        let deliveryAddressOptions = data.map((item: any) => ({
          label: item.deliveryLocationName,
          value: item.id.toString(),
        }));
        setDeliveryAddressOptions(deliveryAddressOptions);
        setDeliveryAddressList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      materialData?.prHeader?.deliveryAddressId &&
      deliveryAddressOptions.length > 0
    ) {
      setValue("deliveryAddressId", materialData.prHeader.deliveryAddressId);
    }
  }, [
    materialData?.prHeader?.deliveryAddressId,
    deliveryAddressOptions,
    setValue,
  ]);

  const fetchDeliveryAddressBySite = async (siteId: any) => {
    try {
      const { data, status } = await deliveryAddressApis.fetchAddressBySite(
        siteId
      );

      if (status) {
        let deliveryAddressOptions = data.map((item: any) => ({
          label: item.deliveryLocationName,
          value: item.id.toString(),
        }));
        setDeliveryAddressOptions(deliveryAddressOptions);
        setDeliveryAddressList(data);
      }
    } catch (error) {
      console.log("Error fetching delivery addresses by site:", error);
    }
  };

  const baseColumns = useMemo<TableColumnsType<any>>(() => {
    const cols: TableColumnsType<any> = [
      {
        title: "#",
        key: "#",
        width: 50,
        fixed: "left",
        render: (text, record, index) => index + 1,
      },
      {
        title: "Material Category",
        dataIndex: "categoryName",
        key: "categoryLabel",
        width: 200,
        fixed: "left",
      },
      {
        title: "Material Name",
        dataIndex: "materialName",
        key: "materialLabel",
        width: 200,
        fixed: "left",
      },
      {
        title: "Make",
        dataIndex: "makeInfo",
        key: "makeInfo",
        width: 150,
        render: (_: any, record: any) => {
          if (record?.makeInfo?.length > 0) {
            return record.makeInfo.map((m: any) => m.makeName).join(", ");
          }
          return record?.makeLabel || "-";
        },
      },
      {
        title: "Specification",
        dataIndex: "specification",
        key: "specification",
        width: 200,
      },
      {
        title: "Req Qty",
        dataIndex: "quantity",
        key: "quantity",
        width: 150,
        render: (text, record) => {
          const formattedNumber = parseFloat(text)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return `${formattedNumber} ${record?.uomName}`;
        },
      },
      {
        title: "Remarks",
        dataIndex: "remarks",
        key: "remarks",
        width: 150,
      },
    ];

    // General info already shows site hierarchy, so skip column here.
    if (hierarchyVis.tower) {
      cols.push({
        title: hierarchyUnitColumnTitle,
        dataIndex: "towerBlockVillaName",
        key: "towerBlockVilla",
        width: 180,
        render: (_: any, record: any) => getTowerLabel(record),
      });
    }
    if (hierarchyVis.floor) {
      cols.push({
        title: "Floor",
        dataIndex: "floorNo",
        key: "floorNo",
        width: 120,
        render: (value: any) => value ?? "-",
      });
    }
    if (hierarchyVis.flat) {
      cols.push({
        title: "Flat",
        dataIndex: "siteStructureSubUnitName",
        key: "flatName",
        width: 160,
        render: (_: any, record: any) => {
          const flatLabel =
            record?.flatLabel ||
            record?.siteStructureSubUnitName ||
            record?.flatName ||
            "-";
          return flatLabel;
        },
      });
    }
    if (hierarchyVis.location) {
      cols.push({
        title: "Location",
        dataIndex: "locationName",
        key: "locationName",
        width: 180,
        render: (_: any, record: any) => getLocationLabel(record),
      });
    }

    cols.push({
      title: "Status",
      dataIndex: "actualStatus",
      key: "actualStatus",
      width: 170,
      render: (text: any, record: any) => (
        <>
          {text}
          {record.status === "PARTIAL_CONVERT" && (
            <Popover
              content={
                <div>
                  <p>
                    Converted Qty:{" "}
                    {!isNaN(Number(record?.awardedQty))
                      ? Number(record.awardedQty).toFixed(2)
                      : "N/A"}
                  </p>
                </div>
              }
              title="Info"
            >
              <InfoCircleOutlined style={{ marginLeft: 8 }} />
            </Popover>
          )}
        </>
      ),
    });

    cols.push({
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 150,
      render: (text, record: any) => (
        <Button
          size="sm"
          color=""
          onClick={() => {
            setEditLineRow(record);
          }}
        >
          <Icon name="edit" />
        </Button>
      ),
    });

    return cols;
  }, [
    getFlatLabel,
    getLocationLabel,
    getSiteHierarchyLabel,
    getTowerLabel,
    hierarchyUnitColumnTitle,
    hierarchyVis,
  ]);

  const filteredColumns = useMemo(() => {
    const operationStatus = ["IN_PROGRESS"];
    return baseColumns.filter((col) => {
      if (
        col.key === "operation" &&
        operationStatus.includes(materialData?.prHeader?.status)
      ) {
        return false;
      }
      return true;
    });
  }, [baseColumns, materialData?.prHeader?.status]);

  useEffect(() => {
    if (editLineRow) {
      setAddNewRowModel(true);
    }
  }, [editLineRow]);

  const ApprovalTimelineContent = () => {
    const approvalsData = materialData?.prApprovals;

    if (!approvalsData || approvalsData?.length === 0) {
      return <Badge color="outline-danger">No</Badge>;
    }

    return (
      <Popover
        content={
          <Timeline className="approval-timeline">
            {approvalsData?.map((approval: any, index: number) => {
              const isApproved = approval.status?.toLowerCase() == "approved";
              const isRejected = approval.status?.toLowerCase() == "rejected";
              return (
                <Timeline.Item
                  key={index}
                  dot={
                    isApproved ? (
                      <CheckCircleOutlined style={{ color: "green" }} />
                    ) : isRejected ? (
                      <CloseCircleOutlined style={{ color: "red" }} />
                    ) : undefined
                  }
                >
                  {approval?.userName}
                  <div className="designation">{approval?.roleName}</div>
                  {approval?.approvalDate && (
                    <div className="designation">
                      {dayjs(approval?.approvalDate).format("DD-MMM-YYYY")}
                    </div>
                  )}
                </Timeline.Item>
              );
            })}
          </Timeline>
        }
        title={<span style={{ color: "#2263b3" }}>Approval Hierarchy</span>}
      >
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer"
        }}>
          <span
            style={{
              color: "#2263b3",
            }}
          >
            <Badge color="outline-success">Yes</Badge>
          </span>
          {isStrictMode && (
            <Badge
              color="warning"
              style={{
                fontSize: "11px",
                cursor: "pointer",
                marginLeft: "4px"
              }}
              title="Sequential approvals required, Approvals must follow the sequence"
            >
              Strict
            </Badge>
          )}
        </div>
      </Popover>
    );
  };

  const SubmitChanges = async (submitStatus: any) => {
    try {
      const _formData = new FormData();
      // const updatedLineItems: any = [];
      // const newLineItems: any = [];
      // const deletedLineItems: any = [];

      // const newfiledata: any = [];
      // const deletedFileData: any = [...deletedAttachments];
      // const updatedFileData: any = [];

      console.log("materialData", materialData);

      let indentDate = dayjs(materialData?.prHeader?.indentDate).format(
        "YYYY-MM-DD"
      );
      let needByDate = dayjs(materialData?.prHeader?.needByDate).format(
        "YYYY-MM-DD"
      );

      let contractorId = materialData?.prHeader?.contractorId
        ? Number(materialData?.prHeader?.contractorId)
        : null;
      let blockId =
        materialData?.prHeader?.levelType == "Block"
          ? Number(materialData?.prHeader?.blockId)
          : null;

      // Only send required fields for PR update
      const submitData: any = {
        prId: materialData?.prHeader?.prId,
        prSequence: materialData?.prHeader?.prSequence,
        prNumber: materialData?.prHeader?.prNumber,
        referenceIndentNumber:
          materialData?.prHeader?.referenceIndentNumber || null,
        status: submitStatus,
        indentDate: indentDate,
        needByDate: needByDate,
        levelType: "Site", // Always pass "Site" as levelType to API
        siteId: Number(materialData?.prHeader?.siteId),
        blockId: blockId,
        requestedBy: Number(materialData?.prHeader?.requestedBy),
        deliveryAddressId: Number(materialData?.prHeader?.deliveryAddressId),
        segmentLevel: materialData?.prHeader?.segmentLevel || null,
      };

      // Only add contractorId if it exists
      if (contractorId) {
        submitData.contractorId = contractorId;
      }

      // Add hierarchy fields if they exist
      if (materialData?.prHeader?.towerBlockVillaId) {
        submitData.towerBlockVillaId = Number(
          materialData.prHeader.towerBlockVillaId
        );
      }
      if (materialData?.prHeader?.floorNo) {
        submitData.floorNo = materialData.prHeader.floorNo;
      }
      if (materialData?.prHeader?.flatId) {
        submitData.flatId = Number(materialData.prHeader.flatId);
      }
      if (materialData?.prHeader?.locationId) {
        submitData.locationId = Number(materialData.prHeader.locationId);
      }

      // Group flattened prLines back to siteStructures[] format for API
      const groupedForUpdate = groupMaterialsBySiteStructure(materialData?.prLines || []);

      const cleanedPrLines = groupedForUpdate.map((group: any) => {
        const cleanLine: any = {
          prLineId: group.prLineId || null, // Preserve for updates
          categoryId: Number(group.categoryId || group.materialCategory),
          materialId: Number(group.materialId || group.materialName),
          quantity: Number(group.totalQuantity), // Total across all site allocations
          uomId: Number(group.uomId),
          remarks: group.remarks || null,
        };

        // Add makeInfo if exists
        if (group.makeInfo?.length > 0) {
          cleanLine.makeInfo = group.makeInfo;
        }

        // Add siteStructures array with preserved IDs for updates
        cleanLine.siteStructures = group.siteStructures.map((site: any) => {
          const siteStructure: any = {
            prLineSiteStructureId: site.prLineSiteStructureId || null, // Critical for updates
            quantity: Number(site.quantity),
          };

          // Add hierarchy fields if they exist
          if (site.unitId) {
            siteStructure.siteStructureUnitId = Number(site.unitId);
          }
          if (site.floorNo) {
            siteStructure.floorNo = site.floorNo;
          }
          if (site.subUnitId) {
            siteStructure.siteStructureSubUnitId = Number(site.subUnitId);
          }
          if (site.locationId) {
            siteStructure.locationId = Number(site.locationId);
          }

          return siteStructure;
        });

        return cleanLine;
      });

      _formData.append("prHeader", JSON.stringify(submitData));
      _formData.append("prLines", JSON.stringify(cleanedPrLines || []));
      _formData.append(
        "prApprovals",
        JSON.stringify(materialData?.prApprovals || [])
      );

      // console.log("submitData", submitData);

      const res = await purchaseRequestApis.newVersion(prId, _formData);
      const { status, message }: any = res;
      if (status) {
        fetchPRDetails();
        Swal.fire("Updated!", message, "success");
        navigate("/view-purchase-requests");
      } else {
        Swal.fire("Error!", message, "error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const ConvertToRFQ = async () => {
    try {
      const { response, status } = await purchaseRequestApis.convertToRFQ(
        materialData?.prHeader?.prId
      );
      if (status) {
        const data = response;
        navigate("/new-rfq", { state: { data } });
      }
    } catch (error) {
      console.log(error);
    }
    setDisableSubmit(false);
  };
  const ConvertToPO = async () => {
    try {
      const { response, status } = await purchaseRequestApis.convertToPO(
        materialData?.prHeader?.prId
      );
      if (status) {
        const data = { ...response };
        const prHeader = materialData?.prHeader || {};
        const headerHierarchy = {
          segmentLevel: prHeader.segmentLevel ?? null,
          workLevelSetting: prHeader.workLevelSetting ?? null,
          towerBlockVillaId:
            prHeader.towerBlockVillaId ?? prHeader.siteStructureUnitId ?? null,
          towerBlockVillaName:
            prHeader.towerBlockVillaName ??
            prHeader.siteStructureUnitName ??
            "",
          siteStructureUnitId:
            prHeader.siteStructureUnitId ?? prHeader.towerBlockVillaId ?? null,
          siteStructureUnitName:
            prHeader.siteStructureUnitName ??
            prHeader.towerBlockVillaName ??
            "",
          floorNo: prHeader.floorNo ?? null,
          flatId: prHeader.flatId ?? prHeader.siteStructureSubUnitId ?? null,
          siteStructureSubUnitId:
            prHeader.siteStructureSubUnitId ?? prHeader.flatId ?? null,
          siteStructureSubUnitName:
            prHeader.siteStructureSubUnitName ?? prHeader.flatLabel ?? "",
          locationId: prHeader.locationId ?? null,
          locationName: prHeader.locationName ?? prHeader.locationLabel ?? "",
        };
        data.header = {
          ...data.header,
          ...headerHierarchy,
        };
        if (Array.isArray(data.lines)) {
          const prLineHierarchyMap = new Map<string | number, any>();
          (materialData?.prLines || []).forEach((line: any) => {
            const key =
              line?.prLineId ?? line?.lineNo ?? line?.uuid ?? line?.materialId;
            if (key != null) {
              prLineHierarchyMap.set(key, line);
            }
          });
          data.lines = data.lines.map((line: any) => {
            const key =
              line?.prLineId ?? line?.lineNo ?? line?.uuid ?? line?.materialId;
            const source = key != null ? prLineHierarchyMap.get(key) : null;
            if (!source) {
              return line;
            }
            return {
              ...line,
              segmentLevel:
                source.segmentLevel ??
                line.segmentLevel ??
                prHeader.segmentLevel ??
                null,
              workLevelSetting:
                source.workLevelSetting ??
                line.workLevelSetting ??
                prHeader.workLevelSetting ??
                null,
              siteStructureUnitId:
                source.siteStructureUnitId ??
                source.towerBlockVillaId ??
                line.siteStructureUnitId ??
                null,
              siteStructureUnitName:
                source.siteStructureUnitName ??
                source.towerBlockVillaName ??
                source.towerBlockVillaLabel ??
                line.siteStructureUnitName ??
                "",
              towerBlockVillaId:
                source.towerBlockVillaId ??
                line.towerBlockVillaId ??
                source.siteStructureUnitId ??
                null,
              towerBlockVillaName:
                source.towerBlockVillaName ??
                source.towerBlockVillaLabel ??
                line.towerBlockVillaName ??
                line.siteStructureUnitName ??
                "",
              floorNo: source.floorNo ?? line.floorNo ?? null,
              siteStructureSubUnitId:
                source.siteStructureSubUnitId ??
                source.flatId ??
                line.siteStructureSubUnitId ??
                null,
              siteStructureSubUnitName:
                source.siteStructureSubUnitName ??
                source.flatLabel ??
                line.siteStructureSubUnitName ??
                "",
              flatId:
                source.flatId ??
                source.siteStructureSubUnitId ??
                line.flatId ??
                null,
              flatLabel:
                source.flatLabel ??
                source.siteStructureSubUnitName ??
                line.flatLabel ??
                "",
              locationId:
                source.locationId ??
                line.locationId ??
                prHeader.locationId ??
                null,
              locationName:
                source.locationName ??
                source.locationLabel ??
                line.locationName ??
                line.locationLabel ??
                prHeader.locationName ??
                prHeader.locationLabel ??
                "",
              locationLabel:
                source.locationLabel ??
                source.locationName ??
                line.locationLabel ??
                line.locationName ??
                prHeader.locationLabel ??
                prHeader.locationName ??
                "",
            };
          });
        }
        navigate("/purchase-order-new", { state: { data } });
      }
    } catch (error) {
      console.log(error);
    }
    setDisableSubmit(false);
  };

  const inactivePR = async () => {
    setShowActionModelVisible(true);
  };

  const handleOk = async () => {
    console.log("11111");
    try {
      const values = await form.validateFields();
      await apiCallToInactivePR(
        materialData?.prHeader?.prId,
        values.inActiveReason
      );
      setShowActionModelVisible(false);
      form.resetFields();
    } catch (error) { }
  };

  const handleCancel = () => {
    setShowActionModelVisible(false);
    setIsModalRejectedVisible(false);
    form.resetFields();
  };

  const apiCallToInactivePR = async (prId: any, reason: string) => {
    // Replace this with your actual API call logic
    try {
      let data = {
        prId: Number(prId),
        remarks: reason,
      };
      const res = await purchaseRequestApis.inactivatePR(data);
      const { response, status, message } = res;
      console.log("data", response);
      if (res.status) {
        Swal.fire("Inactive!", "Budget has been Inactive", "success");
        fetchPRDetails();
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
    }
  };

  const returnBillingDetails = () => {
    let address = currentUser?.registeredAddress;
    if (!address) {
      return {};
    }
    return {
      name: currentUser?.orgName || "",
      addressLine1: address?.addressline1,
      addressLine2: address?.addressLine2,
      city: address?.city || "",
      state: address?.state?.stateName,
      pincode: address.pincode,
      country: address?.country?.countryName,
      gstin: materialData?.prHeader?.gstin || "N/A",
      pan: currentUser?.pan || "",
      cin: currentUser?.cin || "",
    };
  };

  const returnSupplierDetails = () => {
    let seller = OriginalData?.supplierDetails;
    if (!seller) {
      return {};
    }
    return {
      name: OriginalData?.supplierName || "",
      addressLine1: seller?.address?.area || "",
      addressLine2: seller?.address?.district?.districtName || "",
      city: seller?.address?.city || "",
      state: seller?.address?.state?.stateName || "",
      pincode: seller?.address?.pincode || "",
      country: seller?.address?.country?.countryName || "",
      gstin: seller?.gstin || "",
      pan: seller?.pan || "",
      cin: seller?.cin || "",
    };
  };

  const returnDetails = () => {
    let address: any = deliveryAddressList?.find(
      (item: any) => item?.id == materialData?.prHeader?.deliveryAddressId
    );
    return {
      quoteNumber: materialData?.prHeader?.prSequence,
      quoteDate:
        dayjs(materialData?.prHeader?.indentDate).format("DD-MMM-YYYY") ||
        "N/A",
      terms: "",
      expectedShipmentDate:
        dayjs(materialData?.prHeader?.needByDate).format("DD-MMM-YYYY") ||
        "N/A",
      placeofSupply: address?.cityName || "",
      creditDays:
        materialData?.paymentTerms != "Cash and Carry"
          ? materialData?.creditDays
          : 0,
      deliveryAddressString:
        [
          address?.addressLine1,
          address?.addressLine2,
          address?.cityName,
          address?.districtName,
          address?.stateName,
          address?.pincode?.toString(),
          address?.countryName,
        ]
          ?.filter(Boolean)
          ?.join(", ") || "",
      totals: {
        taxableAmount: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.quantity) * Number(b.unitPrice),
            0
          )
        ),
        cgst: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.cgst),
            0
          )
        ),
        sgst: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.sgst),
            0
          )
        ),
        igst: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.igst),
            0
          )
        ),
        total: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.grossTotal),
            0
          )
        ),
      },
      lines: data?.map((item: any, index: any) => {
        let itemDescription = item?.materialName;
        if (item?.description) {
          itemDescription += "\t" + item?.description;
        }
        if (materialData?.deliveryAddressType != "ORDER_LEVEL") {
          let _address = deliveryAddressList?.find(
            (_item: any) => _item?.id == item?.deliveryAddressId
          );
          if (_address) {
            const addressString = [
              _address.addressLine1,
              _address.addressLine2,
              _address.city,
              _address.stateName,
              _address.pincode?.toString(),
              _address.countryName,
            ]
              .filter(Boolean)
              .join(", ");
            itemDescription += "\n\nDelivery Address: " + addressString;
          }
        }
        return {
          sno: index + 1,
          itemDescription,
          specification: item?.specification,
          hsnSac: item?.hsnCode || "--",
          rate: formatDecimal(item?.unitPrice),
          cgstPercentage: Number(item?.cgstPercentage),
          cgstAmount: formatDecimal(item?.cgst),
          sgstPercentage: Number(item?.sgstPercentage),
          sgstAmount: formatDecimal(item?.sgst),
          igstPercentage: Number(item?.igstPercentage),
          igstAmount: formatDecimal(item?.igst),
          taxableAmount: formatDecimal(item?.grossTotal),
          qty: Number(item?.quantity) + " " + item?.uomName,
          uom: item?.uomName,
        };
      }),
    };
  };

  const apiCallToRejectPr = async (prId: any, reason: string) => {
    try {
      const files: File[] = [];
      if (signature.image) {
        files.push(dataURLToFile(signature.image as string, "signature.png"));
      }

      const res = await purchaseRequestApis.reject(prId, reason, files);
      const { status, message } = res;
      if (status) {
        Swal.fire("Approved!", "Purchase Request has been Rejected", "success");
        navigate(-1);
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
      setSignature({
        isActive: false,
        label: "Authorised Signatory",
        image: null,
      });
    }
  };


  const dataURLToFile = (dataUrl: string, fileName: string): File => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  };

  const handleApprove = async (id: string, files: File[] = []) => {
    try {
      const res = await purchaseRequestApis.approve(Number(id), files);
      const { status, message } = res;
      if (status) {
        Swal.fire("Approved!", "Purchase Request has been Approved", "success");
        navigate(-1);
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
      setSignature({
        isActive: false,
        label: "Authorised Signatory",
        image: null,
      });
    }
  };

  useEffect(() => {
    if (accessibility) {
      try {
        const prAccess = accessibility["Purchase Request"];
        const rfqAccess = accessibility["Quotations"];
        if (prAccess) {
          const { add, view, edit, approve, reject, cancel } = prAccess;
          setAllowedActions({ add, view, edit, approve, reject, cancel });
        }
        if (rfqAccess) {
          const { add, view, edit, approve, reject, cancel } = rfqAccess;
          setRfqAllowedActions({ add, view, edit, approve, reject, cancel });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, [accessibility]);
  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility, id } = currentUser;
      setCurrentUserId(id);
      if (siteAccessibility) {
        const sitesOptions = siteAccessibility?.map((item: any) => ({
          label: item.siteName,
          value: item.siteID.toString(),
        }));
        setSitesOptions(sitesOptions);
      }
    }
  }, [currentUser]);

  const openApproveConfirmSwal = () => {
    if (!signature.image) return;

    setIsModalApproveVisible(false);

    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "No, keep it",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const file = dataURLToFile(signature.image as string, "signature.png");
        await handleApprove(approveRecord, [file]);
      } else {
        setIsModalApproveVisible(true);
      }
    });
  };

  const openRejectConfirmSwal = async () => {
    try {
      await form.validateFields();

      if (!signature.image) {
        Swal.fire({
          icon: "info",
          title: "Signature Required",
          text: "Please add your signature before rejecting.",
        });
        return;
      }

      setIsModalRejectedVisible(false);

      Swal.fire({
        title: "Confirm Rejection?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Reject it!",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const values = form.getFieldsValue();
          await apiCallToRejectPr(rejectRecord, values.reason);
        } else {
          setIsModalRejectedVisible(true);
        }
      });
    } catch (e) {
      console.log("Validation failed:", e);
    }
  };

  return (
    <>
      <Head title="Purchase request - Details" />
      <Modal
        isOpen={generalInformationEdit}
        toggle={() => setGeneralInformationEdit(false)}
        className="modal-dialog-centered"
        size="xl"
        backdrop="static"
      >
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setGeneralInformationEdit(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>

        <ModalBody>
          <>
            <h5 className="title">Update General Information</h5>
            <div style={{ marginTop: "15px" }}></div>

            <FormProvider {...methods}>
              <form
                className="content clearfix"
                onSubmit={handleSubmit((data) => {
                  setMaterialData((pre: any) => {
                    const newprHeader = {
                      ...pre.prHeader, // Keep existing values
                      ...data,
                      siteName: sitesOptions.find(
                        (item) => item.value == data?.siteId
                      )?.label,
                      contractorName: contractorOptions.find(
                        (item) => item.value == data?.contractorId
                      )?.label,
                    };

                    console.log("updatedData", newprHeader);

                    const updatedMaterialData = {
                      ...pre, // Keep existing data
                      prHeader: newprHeader, // Update prHeader
                    };

                    return {
                      ...pre,
                      ...data,
                      ...updatedMaterialData,
                    };
                  });
                  setGeneralInformationEdit(false);
                  setAddNewRowModel(false);
                  setEditLineRow(null);
                  // console.log(data);
                  setShowSubmitBtm(true);
                })}
              >
                <Row className="gy-4">
                  <Col lg="4">
                    <FormInput
                      name="referenceIndentNumber"
                      label="Indent Number"
                      required={false}
                      disabled={!!materialData?.prHeader?.referenceIndentNumber}
                      type="text"
                      placeholder="Enter Indent Number"
                      tooltipText="Enter Indent Number."
                    />
                  </Col>
                  <Col lg="4">
                    <FormDatePicker
                      name="indentDate"
                      label="Indent Date"
                      required={true}
                      minDate={new Date()}
                    />
                  </Col>
                  {/* <Col lg="4">
                    <FormSelect
                      name="levelType"
                      label={`Level Type`}
                      options={[
                        { label: "Site", value: "Site" },
                        { label: "Block", value: "Block" },
                      ]}
                      required={true}
                      placeholder="-Select-"
                      tooltipText="Select the site where the materials will be used."
                    />
                  </Col> */}
                </Row>

                <Row className="gy-4 mt-1">
                  <Col lg="4">
                    <FormSelect
                      name="siteId"
                      label={`Site`}
                      options={sitesOptions}
                      required={true}
                      placeholder="-Select-"
                      tooltipText="Select the site where the materials will be used."
                    />
                  </Col>
                  {headerWorkLevelSetting && (
                    <Col lg="4">
                      <FormSelect
                        name="workLevelSetting"
                        label="Site Hierarchy"
                        options={[
                          { label: "Tower / Block", value: "TOWER_BLOCK" },
                          { label: "Villa", value: "VILLA" },
                          { label: "Floor", value: "FLOOR" },
                          { label: "Flat", value: "FLAT" },
                        ]}
                        disabled
                        placeholder="-Select-"
                        tooltipText="Site hierarchy level for this purchase request."
                      />
                    </Col>
                  )}
                  <Col lg="4">
                    <FormSelect
                      name="contractorId"
                      label={`Contractor`}
                      required={true}
                      options={contractorOptions}
                      placeholder="-Select-"
                      tooltipText="Select the contractor for this purchase request."
                    />
                  </Col>
                </Row>
                <Row className="gy-4 mt-1"></Row>
                <Row className="gy-4 mt-1">
                  <Col lg="4">
                    <FormSelect
                      name="requestedBy"
                      required={true}
                      label={`Requested By`}
                      options={usersOptions}
                      placeholder="-Select-"
                    // tooltipText="Select the general ledger account for financial tracking."
                    />
                  </Col>
                  <Col lg="4">
                    <FormDatePicker
                      name="needByDate"
                      label="Need By Date"
                      required={true}
                      minDate={new Date()}
                    />
                  </Col>
                  <Col lg="4">
                    <FormSelect
                      name="approvalRequired"
                      disabled
                      label="Approval Required ?"
                      options={[
                        { label: "Yes", value: "Y" },
                        { label: "No", value: "N" },
                      ]}
                      placeholder="Select"
                      required={true}
                    />
                    <div style={{ display: "none" }}>
                      <FormInput name="approvalsData" label="" type="text" noMaxLength />
                    </div>
                  </Col>
                  <Col lg="4">
                    <FormSelect
                      name="deliveryAddressId"
                      label="Delivery Address"
                      options={deliveryAddressOptions}
                      required={true}
                      placeholder={
                        siteIdWatch ? "-Select-" : "Select a site first"
                      }
                      disabled={!siteIdWatch}
                      tooltipText="Select the delivery address for the purchase order."
                      // popOverOptions={
                      //     <ShowAddressPopOver
                      //         id={deliveryAddressId}
                      //         matchKey="id"
                      //         options={deliveryAddressList}
                      //         text="View Selected Delivery Address"
                      //     />
                      // }
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider style={{ margin: "8px 0" }} />
                          <Space
                            style={{
                              padding: "0 8px 4px",
                              width: "100%",
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Button
                              type="button"
                              color="primary"
                              size="small"
                              // onClick={() => {
                              //     handleModelPopUp(null, "");
                              // }}
                              style={{
                                width: "100%",
                                textAlign: "center",
                              }}
                              disabled={!siteIdWatch}
                            >
                              <span>Add Address</span>
                            </Button>
                          </Space>
                        </>
                      )}
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button
                          className="btn btn-primary btn-md"
                          type="submit"
                          color="primary"
                        >
                          Save
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setGeneralInformationEdit(false);
                            reset();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </form>
            </FormProvider>
          </>
        </ModalBody>
      </Modal>

      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {/* <div
              className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
                sm ? "content-active" : ""
              }`}
            >
              <PurchaseRequestAside updateSm={setSm} sm={sm} />
            </div> */}
            {isLoading == true ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <div className="card-inner card-inner-lg">
                {sm && mobileView && (
                  <div
                    className="toggle-overlay"
                    onClick={() => setSm(!sm)}
                  ></div>
                )}
                <BlockHead size="lg">
                  <BlockBetween>
                    <BlockHeadContent>
                      <BlockTitle tag="h4">
                        <span>
                          PR ID - {materialData?.prHeader?.prSequence} |{" "}
                          {materialData?.prHeader?.actualStatus}{" "}
                        </span>
                      </BlockTitle>
                    </BlockHeadContent>
                    <div className="d-flex">
                      {showSubmitBtm && (
                        <div className="actions clearfix">
                          <ul
                            className="m-auto d-flex align-items-center justify-content-center p-0"
                            style={{
                              flexDirection: "row-reverse",
                            }}
                          >
                            {materialData?.prHeader?.status == "DRAFT" && (
                              <li className="pt-0 pb-0">
                                {disableDraft ? (
                                  <Button color="primary" type="button">
                                    <Spinner size="sm" color="light" />
                                  </Button>
                                ) : (
                                  <Button
                                    color="primary"
                                    type="button"
                                    onClick={() => {
                                      setDisableDraft(true);
                                      Swal.fire({
                                        title: "Are you sure?",
                                        text: "Do you want to save the changes as draft?",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        cancelButtonColor: "#d33",
                                        confirmButtonText: "Yes, save it!",
                                        cancelButtonText: "No, cancel",
                                      }).then(async (result) => {
                                        if (result.isConfirmed) {
                                          await SubmitChanges("DRAFT");
                                        } else {
                                          setDisableDraft(false);
                                        }
                                      });
                                    }}
                                  >
                                    Save Draft
                                  </Button>
                                )}
                              </li>
                            )}
                            <li className="pt-0 pb-0">
                              {disableSubmit ? (
                                <Button color="primary" type="button">
                                  <Spinner size="sm" color="light" />
                                </Button>
                              ) : (
                                <Button
                                  color="primary"
                                  type="button"
                                  onClick={() => {
                                    setDisableSubmit(true);
                                    Swal.fire({
                                      title: "Are you sure?",
                                      text: "Do you want to submit the changes?",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: "#3085d6",
                                      cancelButtonColor: "#d33",
                                      confirmButtonText: "Yes, submit it!",
                                      cancelButtonText: "No, cancel",
                                    }).then(async (result) => {
                                      if (result.isConfirmed) {
                                        await SubmitChanges("SUBMIT");
                                      } else {
                                        setDisableSubmit(false);
                                      }
                                    });
                                  }}
                                >
                                  Save Changes
                                </Button>
                              )}
                            </li>
                            <li className="pt-0 pb-0">
                              <Button
                                color="secondary"
                                onClick={() => {
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "Do you want to revert the changes?",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes, revert it!",
                                    cancelButtonText: "No, cancel",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      fetchPRDetails();
                                      Swal.fire(
                                        "Reverted!",
                                        "Your changes have been reverted.",
                                        "success"
                                      );
                                    } else {
                                      setDisableSubmit(false);
                                    }
                                  });
                                }}
                                type="button"
                                className="btn-dim btn btn-secondary"
                              >
                                Revert Changes
                              </Button>
                            </li>
                          </ul>
                        </div>
                      )}

                      {materialData?.prHeader?.status == "DRAFT" &&
                        !showSubmitBtm && (
                          <div className="paddingLeft10">
                            {disableSubmit ? (
                              <Button color="primary" type="button">
                                <Spinner size="sm" color="light" />
                              </Button>
                            ) : (
                              <Button
                                className="toggle"
                                color="primary"
                                onClick={() => {
                                  setDisableSubmit(true);
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "Do you want to submit?",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes, submit it!",
                                    cancelButtonText: "No, cancel",
                                  }).then(async (result) => {
                                    if (result.isConfirmed) {
                                      await SubmitChanges("SUBMIT");
                                    } else {
                                      setDisableSubmit(false);
                                    }
                                  });
                                }}
                              >
                                <span>Submit</span>
                              </Button>
                            )}
                          </div>
                        )}

                      {!showSubmitBtm && (
                        <div className="paddingLeft10">
                          <PdfGenerator
                            buyerDetails={returnBillingDetails()}
                            supplierDetails={returnSupplierDetails()}
                            Details={returnDetails()}
                            buyerOrgLogo={currentUser?.orgLogo}
                            hasIGST={false}
                            prApprovals={materialData?.prApprovals || []}
                          />
                        </div>
                      )}

                      {OriginalData?.prHeader?.version > 1 ? (
                        <li className="pt-0 pb-0">
                          <Button
                            color="primary"
                            type="button"
                            onClick={() => {
                              navigate("/prHistor", {
                                state: {
                                  prSequence:
                                    OriginalData?.prHeader?.prSequence,
                                  prId: OriginalData?.prHeader?.prId,
                                },
                              });
                            }}
                          >
                            Version History
                          </Button>
                        </li>
                      ) : (
                        <></>
                      )}

                      {!showSubmitBtm && (
                        <div className="paddingLeft10">
                          <Button
                            className="toggle"
                            color="primary"
                            onClick={async () => {
                              const locationState = location.state as any;
                              const previousPath = locationState?.previousPath;
                              if (previousPath) {
                                navigate(previousPath, {
                                  state: {
                                    openDrawer: locationState?.openDrawer,
                                    categoryId: locationState?.categoryId,
                                    startDate: locationState?.startDate,
                                    endDate: locationState?.endDate,
                                  },
                                });
                              } else {
                                navigate("/view-purchase-requests");
                              }
                            }}
                          >
                            <Icon name="arrow-left" />
                            <span>Back</span>
                          </Button>
                        </div>
                      )}

                      {(() => {
                        const headerStatus = materialData?.prHeader?.status;
                        const canApproveReject =
                          headerStatus?.toLowerCase() === "pending" &&
                          allowedActions?.approve == 1 &&
                          !hasUserAlreadyApproved;
                        const canDeactivate = headerStatus == "OPEN";
                        // Use original (unflattened) prLines so line status is present
                        const hasConvertibleLine = (
                          OriginalData?.prLines || []
                        ).some((e: any) =>
                          ["OPEN", "PARTIAL_CONVERT"].includes(e?.status)
                        );
                        const canConvert =
                          (headerStatus == "OPEN" || hasConvertibleLine) &&
                          !!rfqAllowedActions?.add;
                        return canApproveReject || canDeactivate || canConvert;
                      })() && (
                        <ul className="nk-tb-actions ms-2">
                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                tag="a"
                                className="dropdown-toggle btn btn-icon btn-trigger"
                              >
                                <Icon name="more-v"></Icon>
                              </DropdownToggle>
                              <DropdownMenu end>
                              <ul className="link-list-opt no-bdr">

                                {materialData?.prHeader?.status?.toLowerCase() === "pending" &&
                                  allowedActions?.approve == 1 &&
                                  !hasUserAlreadyApproved &&
                                  (

                                    <>
                                      {canUserApproveReject() ? (
                                        <>
                                          <li
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setApproveRecord(materialData?.prHeader?.prId);
                                              setActiveSignatureContext("APPROVE");
                                              setIsModalApproveVisible(true);
                                              const dropdown = document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                              if (dropdown) {
                                                dropdown.classList.remove("show");
                                              }
                                            }}
                                          >
                                            <Link to={`#`}>
                                              <Icon name="check" /> Approve
                                            </Link>
                                          </li>
                                          <li
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setRejectRecord(materialData?.prHeader?.prId);
                                              setActiveSignatureContext("REJECT");
                                              setIsModalRejectedVisible(true);
                                              const dropdown = document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                              if (dropdown) {
                                                dropdown.classList.remove("show");
                                              }
                                            }}
                                          >
                                            <Link to={`#`}>
                                              <Icon name="cross" /> Reject
                                            </Link>
                                          </li>
                                        </>
                                      ) : (
                                        <><li className="disabled" style={{ position: 'relative' }}>
                                          <div
                                            className="d-flex align-items-center justify-content-between w-100"
                                            style={{
                                              padding: "8px 16px",
                                              opacity: 0.6,
                                              cursor: "not-allowed",
                                            }}
                                          >
                                            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                              <Icon name="check" />
                                              <span>Approve</span>
                                            </div>
                                            <Popover
                                              content={
                                                <div style={{ padding: "8px", maxWidth: "300px" }}>
                                                  <p style={{ margin: 0 }}>{getPendingStatusMessage()}</p>
                                                </div>
                                              }
                                              title="Approval Status"
                                              trigger="hover"
                                            >
                                              <InfoCircleOutlined
                                                style={{
                                                  fontSize: "16px",
                                                  cursor: "pointer",
                                                  color: "#2263b3",
                                                  marginLeft: "8px"
                                                }}
                                              />
                                            </Popover>
                                          </div>
                                        </li>
                                          <li className="disabled">
                                            <div
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "8px 16px",
                                                opacity: 0.6,
                                                cursor: "not-allowed",
                                                gap: "8px"
                                              }}
                                            >
                                              <Icon name="cross" />
                                              <span>Reject</span>
                                            </div>
                                          </li>
                                        </>
                                      )}
                                    </>
                                  )}


                                {materialData?.prHeader?.status == "OPEN" && (
                                  <li
                                    onClick={() => {
                                      {
                                        Swal.fire({
                                          title: "Are you sure?",
                                          text: "Do you want to Inactive this PR?",
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: "#3085d6",
                                          cancelButtonColor: "#d33",
                                          confirmButtonText:
                                            "Yes, Inactive it!",
                                          cancelButtonText: "No, cancel",
                                        }).then((result) => {
                                          if (result.isConfirmed) {
                                            inactivePR();
                                          } else {
                                            setDisableSubmit(false);
                                          }
                                        });
                                      }
                                    }}
                                  >
                                    <Link to={`#`}>
                                      <span>Deactivate Indent</span>
                                      <Icon
                                        className="text-danger"
                                        name="pause-circle"
                                      ></Icon>
                                    </Link>
                                  </li>
                                )}

                                {(materialData?.prHeader?.status == "OPEN" ||
                                  (OriginalData?.prLines || []).some(
                                    (e: any) =>
                                      ["OPEN", "PARTIAL_CONVERT"].includes(
                                        e?.status
                                      )
                                  )) &&
                                  !!rfqAllowedActions?.add && (
                                    <>
                                      <li onClick={ConvertToRFQ}>
                                        <Link to={`#`}>
                                          {/* <Icon
                                                
                                              ></Icon> */}
                                          <span>Convert To RFQ</span>
                                        </Link>
                                      </li>
                                      <li onClick={ConvertToPO}>
                                        <Link to={`#`}>
                                          {/* <Icon
                                               
                                              ></Icon> */}
                                          <span>Convert To PO</span>
                                        </Link>
                                      </li>
                                    </>
                                  )}
                                </ul>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                        </ul>
                      )}
                    </div>
                    <BlockHeadContent className="align-self-start d-lg-none">
                      <Button
                        className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""
                          }`}
                        onClick={() => setSm(!sm)}
                      >
                        <Icon name="menu-alt-r" />
                      </Button>
                    </BlockHeadContent>
                  </BlockBetween>
                </BlockHead>

                <div className="content clearfix">
                  <AntCollapse defaultActiveKey={["1", "2", "3"]}>
                    <Panel header="General Information" key="1">
                      {/* {poStatus} */}
                      {poStatus !== "IN_PROGRESS" && (
                          <span
                            className="cursor-pointer position-absolute"
                            style={{
                              right: 40,
                              top: 75,
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              // if(["Pending Approval"].includes(poStatus)){
                              setValue(
                                "referenceIndentNumber",
                                materialData?.prHeader?.referenceIndentNumber
                              );
                              setValue(
                                "indentDate",
                                dayjs(materialData?.prHeader?.indentDate)
                              );
                              setValue(
                                "requestedBy",
                                materialData?.prHeader?.requestedBy
                              );
                              // setValue(
                              //   "levelType",
                              //   materialData?.prHeader?.levelType
                              // );
                              setValue(
                                "needByDate",
                                dayjs(materialData?.prHeader?.needByDate)
                              );
                              setValue(
                                "deliveryAddressId",
                                materialData?.prHeader?.deliveryAddressId
                              );
                              setValue(
                                "siteId",
                                materialData?.prHeader?.siteId
                              );
                              if (headerWorkLevelSetting) {
                                setValue(
                                  "workLevelSetting",
                                  headerWorkLevelSetting
                                );
                              }
                              setValue(
                                "contractorId",
                                materialData?.prHeader?.contractorId
                              );
                              setValue(
                                "approvalRequired",
                                materialData?.prHeader?.approvalRequired
                              );

                              setGeneralInformationEdit(true);
                            }}
                          >
                            <Icon name="edit" />
                          </span>
                        )}
                      {/* <div className="tab-content mt-0"> */}
                      {/* <div className={`tab-pane${tab === "1" && " active"}`}> */}
                      <Col className="justify-start w-100  flex-wrap mt-3 p-3">
                        <div className="w-30 border-end ">
                          <div className="data-col align-center pt-1 ">
                            <div className="data-label w-45">Site</div>
                            <div className="data-value w-55 ">
                              {
                                sitesOptions.find(
                                  (item) =>
                                    item.value == materialData?.prHeader?.siteId
                                )?.label
                              }
                            </div>
                          </div>
                          <div className="data-col align-center pt-1 ">
                            <div className="data-label w-45">
                              Site Hierarchy
                            </div>
                            <div className="data-value w-55 ">
                              {materialData?.prHeader?.segmentLevel || "Site"}
                            </div>
                          </div>
                          <div className="data-col align-center pt-1 ">
                            <div className="data-label w-45">
                              Reference Indent Number
                            </div>
                            <div className="data-value w-55 ">
                              {materialData?.prHeader?.referenceIndentNumber ||
                                "NA"}
                            </div>
                          </div>
                          <div className="data-col align-center pt-1">
                            <div className="data-label w-45">Indent Date</div>
                            <div className="data-value w-55">
                              {dayjs(materialData?.prHeader?.indentDate).format(
                                "DD-MMM-YYYY"
                              ) || "--"}
                            </div>
                          </div>
                          {/* <div className="data-col align-center pt-1 ">
                            <div className="data-label w-45">Level Type</div>
                            <div className="data-value w-55 ">
                              {materialData?.prHeader?.levelType}
                            </div>
                          </div>
                          {materialData?.prHeader?.levelType === "Block" && (
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-45">Block</div>
                              <div className="data-value w-55 ">
                                {materialData?.prHeader?.blockName}
                              </div>
                            </div>
                          )} */}
                        </div>
                        <div className="w-30 border-end paddingLeft10  ">
                          <div className="data-col align-center pt-1 ">
                            <div className="data-label w-30">Contractor</div>
                            <div className="data-value w-70 ">
                              {contractorOptions.find(
                                (item) =>
                                  item.value ==
                                  materialData?.prHeader?.contractorId
                              )?.label ||
                                materialData?.prHeader?.contractorName ||
                                "NA"}
                            </div>
                          </div>
                          <div className="data-col align-center pt-1 ">
                            <div className="data-label w-30">Requested By</div>
                            <div className="data-value w-70 ">
                              {materialData?.prHeader?.requestByName}
                            </div>
                          </div>
                          <div className="data-col align-center pt-1">
                            <div className="data-label w-30">Need By Date</div>
                            <div className="data-value w-70">
                              {dayjs(materialData?.prHeader?.needByDate).format(
                                "DD-MMM-YYYY"
                              ) || "--"}
                            </div>
                          </div>
                          <div className="data-col align-center pt-1">
                            <div className="data-label w-30">Approvals</div>
                            <div className="data-value w-70">
                              <ApprovalTimelineContent />
                            </div>
                          </div>
                        </div>
                        <div className="w-30 paddingLeft10">
                          <div className=" pt-1">
                            <div className="data-label w-9 mb-1">
                              Delivery Address
                            </div>
                            <div className="data-value w-90">
                              <ShowAddressPopOver
                                id={materialData?.prHeader?.deliveryAddressId}
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                      {/* </div> */}
                      {/* </div> */}
                    </Panel>
                    <Panel header="Material Information" key="2">
                      <div className="table-responsive poTable">
                        <div
                          style={{
                            width: screenSize - 180 + "px",
                            margin: "auto",
                          }}
                        >
                          <Table
                            className="customTable"
                            rowKey={(record: any) => record.rowUid || record.key}
                            columns={filteredColumns?.map((col) => {
                              const { key } = col;
                              if (key == "specification") {
                                col = {
                                  ...col,
                                  render: (text: any, record: any) => {
                                    if (record?.key == "lastRow") {
                                      return (
                                        <b className="justify-end">
                                          Total Qty:{" "}
                                        </b>
                                      );
                                    } else {
                                      return text;
                                    }
                                  },
                                  onCell: (record: any) => {
                                    if (record?.key == "lastRow") {
                                      return {
                                        colSpan: 5,
                                      };
                                    }
                                    return {};
                                  },
                                };
                              } else if (key == "quantity") {
                                col = {
                                  ...col,
                                  render: (
                                    text: any,
                                    record: any,
                                    index: number
                                  ) => {
                                    if (record?.key == "lastRow") {
                                      const total =
                                        materialData?.prLines?.reduce(
                                          (a: any, b: any) => {
                                            return +a + +b?.quantity;
                                          },
                                          0
                                        );
                                      return (
                                        <div className="justify-end">
                                          {Number(total).toFixed(2)}
                                        </div>
                                      );
                                    }
                                    return (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "flex-end",
                                        }}
                                      >
                                        <div>
                                          {Number(text).toFixed(2)}{" "}
                                          {record?.uom || record?.uomName}
                                        </div>
                                        {record?.quantityOnHand !== undefined &&
                                          record?.quantityOnHand !== null && (
                                            <div
                                              style={{
                                                color: "#52c41a",
                                                marginTop: "4px",
                                              }}
                                            >
                                              Qyt Avl:{" "}
                                              {Number(
                                                record?.quantityOnHand
                                              ).toFixed(2)}{" "}
                                              {record?.stockAvailabilityUom ||
                                                record?.uom ||
                                                record?.uomName}
                                            </div>
                                          )}
                                      </div>
                                    );
                                  },
                                };
                              } else {
                                col = {
                                  ...col,
                                  onCell: (record: any) => {
                                    if (record?.key == "lastRow") {
                                      return {
                                        colSpan: 0,
                                      };
                                    }
                                    return {};
                                  },
                                };
                              }
                              return col;
                            })}
                            dataSource={
                              materialData?.prLines?.length > 0
                                ? [
                                  ...materialData?.prLines,
                                  {
                                    key: "lastRow",
                                    materialName: "",
                                    quantity: 0,
                                    unit: 0,
                                    lineTotal: 0,
                                  },
                                ]
                                : []
                            }
                            scroll={{ x: 1000 }}
                            locale={{
                              emptyText: (
                                <span
                                  style={{
                                    height: "300px",
                                    color: "#333",
                                    fontSize: "16px",
                                  }}
                                >
                                  Please click on "Add New Item" to add purchase
                                  order lines.
                                </span>
                              ),
                            }}
                            bordered
                            size="middle"
                            pagination={{
                              defaultPageSize: 10,
                              showSizeChanger: true,
                              pageSizeOptions: ['10', '20', '50', '100', '200'],
                              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} materials`,
                            }}
                          />
                        </div>
                        {materialData?.prLines?.length > 0 && (
                          <Row
                            style={{
                              margin: "20px",
                            }}
                          >
                            {poStatus !== "IN_PROGRESS" && (
                                <Col
                                  className={`${poStatus !== "Pending Approval"
                                    ? "justify-between"
                                    : "justify-end"
                                    }`}
                                >
                                  {/* {poStatus == "Pending Approval" && ( */}
                                  <a
                                    onClick={() => {
                                      setAddNewRowModel(true);
                                      setEditLineRow(null);
                                    }}
                                    href="#add"
                                    className="addNewItem"
                                  >
                                    <Icon name="plus-round" />
                                    <span>Add New Item</span>
                                  </a>
                                  {/* )} */}
                                </Col>
                              )}
                          </Row>
                        )}
                      </div>
                    </Panel>
                  </AntCollapse>
                  <Block>
                    {addNewRowModel && (
                      <MaterialModal
                        modal={addNewRowModel}
                        closeModal={() => {
                          setAddNewRowModel(false);
                          setEditLineRow(null);
                        }}
                        materialCategoryOptions={materialCategoryOptions}
                        status={materialData?.prHeader?.status}
                        orderContext={materialData?.prHeader}
                        formData={{
                          action: editLineRow == null ? "add" : "edit",
                          index: editLineRow?.rowUid,
                          item: editLineRow,
                        }}
                        append={(data: any) => {
                          console.log("Append", data, materialData);
                          let newLineItems = materialData?.prLines || [];
                          console.log(materialData?.prLines, "newLineItems");
                          const _data = newLineItems.find(
                            (item: any) =>
                              item.materialId == data.materialId &&
                              item.siteStructureUnitId == data.siteStructureUnitId &&
                              item.floorNo == data.floorNo &&
                              item.siteStructureSubUnitId == data.siteStructureSubUnitId &&
                              item.locationId == data.locationId
                          );

                          if (_data) {
                            Swal.fire({
                              icon: "error",
                              title: "Error",
                              text: "Material Already Added",
                            });
                            return;
                          }

                          setMaterialData((prev: any) => {
                            let newData = {
                              ...prev,
                              prLines: [
                                ...prev.prLines,
                                { ...data, rowUid: makeRowUid() }, // Tag new row with a unique id
                              ],
                            };
                            console.log(newData, "newData");
                            return newData;
                          });
                          // setData((pre: any) => {
                          //     console.log("[...pre, data]", [...pre, data]);
                          //     return [...pre, data];
                          // });
                          setShowSubmitBtm(true);
                        }}
                        update={(id: any, data: any) => {
                          console.log(
                            "update",
                            data,
                            id,
                            materialData?.prLines
                          );
                          let newLineItems = materialData?.prLines || [];

                          // Check for duplicates, but exclude the current item being
                          // edited. Identity is the client-side rowUid — prLineId /
                          // prLineSiteStructureId are null for newly added rows and
                          // collide (null == null) across every new row.
                          const _data = newLineItems.find(
                            (item: any) => {
                              // Skip the current item being edited
                              if (item.rowUid === id) {
                                return false;
                              }

                              // Check for duplicate site structure
                              return (
                                item.materialId == data.materialId &&
                                item.siteStructureUnitId == data.siteStructureUnitId &&
                                item.floorNo == data.floorNo &&
                                item.siteStructureSubUnitId == data.siteStructureSubUnitId &&
                                item.locationId == data.locationId
                              );
                            }
                          );

                          if (_data) {
                            Swal.fire({
                              icon: "error",
                              title: "Error",
                              text: " Material Already Added",
                            });
                            return;
                          }

                          // Update only the row whose rowUid matches
                          const updatedLines = newLineItems.map((item: any) => {
                            if (item.rowUid === id) {
                              return { ...data, rowUid: item.rowUid };
                            }
                            return item;
                          });

                          setMaterialData((prev: any) => ({
                            ...prev,
                            prLines: updatedLines, // Update prLines immutably
                          }));

                          setData(updatedLines);
                          setShowSubmitBtm(true);
                        }}
                        materialsList={materialData?.prLines}
                        boqData={boqData}
                      />
                    )}
                  </Block>
                </div>
              </div>
            )}
          </div>
        </Card>
      </Content>

      <AntModal
        title={"Deactivate Indent"}
        visible={showActionModelVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Submit"
        cancelText="Cancel"
      >
        <Form form={form} layout="vertical" name="inactiveForm">
          <Form.Item
            name="inActiveReason"
            label="Reason for Inactive"
            rules={[{ required: true, message: "Please input your reason!" }]}
          >
            <Input.TextArea placeholder="Type your reason here..." />
          </Form.Item>
        </Form>
      </AntModal>

      <AntModal
        title="Approve Purchase Request"
        visible={isModalApproveVisible}
        onOk={() => {
          if (!signature.image) {
            Swal.fire({
              icon: "info",
              title: "Signature Required",
              text: "Please add your signature before approving.",
            });
            return;
          }
          openApproveConfirmSwal();
        }}

        onCancel={() => {
          setIsModalApproveVisible(false);
          setSignature({ isActive: false, label: "Authorised Signatory", image: null });
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span style={{ fontSize: 14, fontWeight: 600 }}>Signature</span>

            {signature.image && (
              <button
                type="button"
                onClick={() =>
                  setSignature({
                    isActive: true,
                    label: "Authorised Signatory",
                    image: null,
                  })
                }
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  cursor: "pointer",
                }}
              >
              </button>
            )}
          </div>

          {signature.image ? (
            <>
              <div
                className="border mb-3 d-flex justify-content-center align-items-center"
                style={{
                  padding: 16,
                  borderRadius: 8,
                  background: "#fff",
                }}
              >
                <img
                  src={signature.image}
                  alt="Signed"
                  style={{ maxWidth: 220, maxHeight: 120, objectFit: "contain" }}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  onClick={() =>
                    setSignature({
                      isActive: true,
                      label: "Authorised Signatory",
                      image: null,
                    })
                  }
                >
                  Reset
                </Button>
              </div>
            </>
          ) : (
            <div
              style={{
                width: "100%",
                minHeight: 220,
                border: "2px dashed #dee2e6",
                borderRadius: 8,
                backgroundColor: "#f8f9fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 12,
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <ImageUploadCropper
                  onOpenCrop={() => setIsModalApproveVisible(false)}
                  onCloseCrop={() => setIsModalApproveVisible(true)}
                  onSave={(data: string) => {
                    setSignature((prev: any) => ({ ...prev, image: data }));
                  }}
                >
                  <Button color="primary" size="sm" outline style={{ minWidth: 140 }} onClick={() => setActiveSignatureContext("APPROVE")}>
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  style={{ minWidth: 140 }}
                  onClick={() => {
                    setIsModalApproveVisible(false);
                    setShowSignatureModel(true);
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </div>
      </AntModal >

      <AntModal
        title="Reject Purchase Request"
        visible={isModalRejectedVisible}
        onOk={openRejectConfirmSwal}
        onCancel={() => {
          handleCancel();
          setSignature({ isActive: false, label: "Authorised Signatory", image: null });
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <Form form={form} layout="vertical" name="rejectForm">
          <Form.Item
            name="reason"
            label="Reason for Rejection"
            rules={[{ required: true, message: "Please input your reason!" }]}
          >
            <Input.TextArea rows={3} placeholder="Type your reason here..." />
          </Form.Item>

          <div className="mt-4">
            <strong style={{ fontSize: "16px" }}>Signature</strong>
          </div>

          {signature.image && (
            <a
              style={{ fontSize: 14, cursor: "pointer" }}
              onClick={() =>
                setSignature({ isActive: true, label: "Authorised Signatory", image: null })
              }
            >
            </a>
          )}


          {signature.image ? (
            <>
              <div className="signatueImgWrapper border mb-3 p-3 text-center">
                <img
                  src={signature.image}
                  alt="Signed"
                  style={{ width: "180px", height: "auto" }}
                />
              </div>
              <div className="d-flex justify-content-end mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  className="me-2"
                  onClick={() =>
                    setSignature({ isActive: true, label: "Authorised Signatory", image: null })
                  }
                >
                  Reset
                </Button>
              </div>

            </>
          ) : (
            <div
              style={{
                minHeight: "200px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "15px",
                border: "2px dashed #dee2e6",
                borderRadius: "8px",
                backgroundColor: "#f8f9fa"
              }}
            >
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center" }}>
                <ImageUploadCropper
                  onOpenCrop={() => setIsModalRejectedVisible(false)}
                  onCloseCrop={() => setIsModalRejectedVisible(true)}
                  onSave={(data: string) => {
                    setSignature((prev: any) => ({ ...prev, image: data }));
                  }}
                >
                  <Button color="primary" size="sm" outline onClick={() => setActiveSignatureContext("REJECT")}>
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  onClick={() => {
                    setIsModalRejectedVisible(false);
                    setShowSignatureModel(true);
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </Form>
      </AntModal>


      {showSignatureModel && (
        <SignatureModal
          modal={showSignatureModel}
          toggle={() => {
            setShowSignatureModel(false);
            if (activeSignatureContext === "APPROVE") {
              setIsModalApproveVisible(true);
            } else if (activeSignatureContext === "REJECT") {
              setIsModalRejectedVisible(true);
            }
          }}
          onSave={(data: string) => {
            setSignature((prev: any) => ({ ...prev, image: data }));
            setShowSignatureModel(false);

            if (activeSignatureContext === "APPROVE") {
              setIsModalApproveVisible(true);
            } else if (activeSignatureContext === "REJECT") {
              setIsModalRejectedVisible(true);
            }
          }}
        />
      )}
    </>
  );
};

export default ViewPRDetails;